import React from 'react'
import s from './ExpenseReport.less'
import T from '../i18n/T'
import ArrivalMarkerHTML from '../itinerary/steps/ArrivalMarkerHTML'
import { selectArrivalStep, selectDepartureStep, selectStopSteps } from '../itinerary/steps/steps.selectors'
import { useSelector } from 'react-redux'
import classNames from 'classnames'

const ExpenseReportComputedItinerarySection = () => {
  const departure = useSelector(selectDepartureStep)
  const arrival = useSelector(selectArrivalStep)
  const stops = useSelector(selectStopSteps)

  return (
    <div className={s.block}>
      <h2>
        <T id={'itinerary.expense.computed-route'} />
      </h2>
      <div className={s.timeline}>
        <div className={classNames(s.step, s.departure, s.bottomBorder)}>
          <strong>
            <T id={'itinerary.expense.departure'} />
          </strong>{' '}
          : {departure?.label}
        </div>
        {stops.map((stop, idx) => (
          <div className={classNames(s.step, s.stop, s.bottomBorder)} key={idx}>
            <strong>
              <T id={'itinerary.step'} /> {idx + 1}
            </strong>{' '}
            : {stop?.label}
          </div>
        ))}
        <div className={classNames(s.step)}>
          <div className={s.arrivalIcon}>
            <ArrivalMarkerHTML />
          </div>
          <strong>
            <T id={'itinerary.expense.arrival'} />
          </strong>{' '}
          : {arrival?.label}
        </div>
      </div>
    </div>
  )
}

export default ExpenseReportComputedItinerarySection
